import { IconButton } from "@mui/material";
import { useUnreadMessage, useReadMessage } from "../../App/Queries/MessageQueries";
import { useCurrentUser } from "../../App/Queries/UserQueries";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import MarkChatReadIcon from "@mui/icons-material/MarkChatRead";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";

export default function MessageActionsMenu({
  size = "medium",
  messageId,
  hasBeenRead,
  onChange,
  messageType,
}: {
  size?: "small" | "medium" | "large";
  messageId: string;
  hasBeenRead: boolean;
  onChange?: () => void;
  messageType: "email" | "sms";
}) {
  const { mutateAsync: unreadAsync } = useUnreadMessage();
  const { mutateAsync: readAsync } = useReadMessage();
  const { id: userId } = useCurrentUser();

  return (
    <IconButton
      size={size}
      title={`Mark as ${hasBeenRead ? "unread" : "read"}`}
      data-test={`message-unread-${messageId}`}
      onClick={async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (hasBeenRead) {
          await unreadAsync({
            messageIds: [messageId],
            userId: userId,
          });
        } else {
          await readAsync({
            messageIds: [messageId],
            userId: userId,
          });
        }
        onChange?.();
      }}
    >
      {getIcon(messageType, hasBeenRead, size)}
    </IconButton>
  );
}

const getIcon = (messageType: "email" | "sms", hasBeenRead: boolean, size: "small" | "medium" | "large") => {
  if (messageType === "email") {
    return hasBeenRead ? <MarkEmailUnreadIcon fontSize={size} /> : <MarkEmailReadIcon fontSize={size} />;
  }

  return hasBeenRead ? <MarkChatUnreadIcon fontSize={size} /> : <MarkChatReadIcon fontSize={size} />;
};
